import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import { getItemIdentifiers, isItemIdentifiersComplete } from '../helpers'
import MissingInfoChip from '../MissingInfoChip/MissingInfoChip'
import * as Styles from './styles'

const ItemIdentifiers = ({ item }) => {
  const { t } = useTranslation()
  const identifiers = getItemIdentifiers(item)

  if (!isItemIdentifiersComplete(item)) return <MissingInfoChip />
  if (!identifiers.length) return '-'

  return (
    <Styles.Container>
      {identifiers.map(identifier => (
        <Text key={identifier.label} type="bodyMRegular">
          {t(identifier.label)}: {identifier.value}
        </Text>
      ))}
    </Styles.Container>
  )
}

export default ItemIdentifiers
